import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getProviderNPI = (provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_NPI_REQUEST });

  return api.claim.npi.getProviderNPI(provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_NPI_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_NPI_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getOther = (provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_OTHER_PROVIDER_NPI_REQUEST });

  return api.claim.npi.getOther(provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_OTHER_PROVIDER_NPI_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_OTHER_PROVIDER_NPI_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const checkIsDME = (provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_IS_DME_REQUEST });

  return api.claim.npi.checkIsDME(provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_IS_DME_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_IS_DME_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const validateRendering = (npi: string, provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.VALIDATE_RENDERING_NPI_REQUEST });

  return api.claim.npi.validateRendering(npi, provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.VALIDATE_RENDERING_NPI_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.VALIDATE_RENDERING_NPI_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const verify = (npi: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.VERIFY_NPI_REQUEST });

  return api.claim.npi.verify(npi)
    .then((res: any) => {

      dispatch({
        type: types.VERIFY_NPI_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.VERIFY_NPI_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getName = (npi: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_NAME_FROM_NPI_REQUEST });

  return api.claim.npi.getName(npi)
    .then((res: any) => {

      dispatch({
        type: types.GET_NAME_FROM_NPI_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_NAME_FROM_NPI_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getRmiProvKeyId = (npi: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_RMIPROVKEYID_FROM_NPI_REQUEST });

  return api.claim.npi.getRmiProvKeyId(npi, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_RMIPROVKEYID_FROM_NPI_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_RMIPROVKEYID_FROM_NPI_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const getNameAndIdFromRmiProvKeyId = (rmiProvKeyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_NAME_AND_ID_FROM_RMIPROVKEYID_REQUEST });

  return api.claim.npi.getNameAndIdFromRmiProvKeyId(rmiProvKeyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_NAME_AND_ID_FROM_RMIPROVKEYID_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_NAME_AND_ID_FROM_RMIPROVKEYID_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
